export default __webpack_public_path__ + "static/media/german.a2b93683.webp";